import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoMasterDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoMasterService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getProyectoMasterService(): Observable<BodyListResponse<ProyectoMasterDTO>> {
    return this.http.get<BodyListResponse<ProyectoMasterDTO>>(API_URL + '/api/v1/proyectoMaster/todos');
  }

  guardarProyectoMasterService(proyectoMasterDTO: ProyectoMasterDTO): Observable<BodyResponse<ProyectoMasterDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/proyectoMaster', proyectoMasterDTO);
  }

  getProyectoMasterPorCodigoService(codigo: string): Observable<BodyResponse<ProyectoMasterDTO>> {
    return this.http.get<BodyResponse<ProyectoMasterDTO>>(API_URL + '/api/v1/proyectoMaster/' + codigo);
  }
}
